export default __webpack_public_path__ + "static/media/blue-sea.c92984a000d6fc92ce0ba7da05232365.svg";